import React from "react";

import { observer } from "mobx-react";
import { Bet } from "@models";
import { useTranslation } from "react-i18next";

export const StakePerBet = observer(function StakePerBet(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">
				{t("ITEM.ADDITIONAL_STAKE_PER_BET")}
			</div>
			<div className="bet__details__col">
				{bet.displayPaymentPerCombination}
			</div>
		</div>
	);
});
